import AppButton from "components/AppButton/AppButton";
import ContainerFlex from "components/ContainerFlex";
import useApi, { ApiMethod } from "hooks/useApi";
import { SecurityPageProps } from "models/security";
import moment from "moment";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { selectAntecipationList } from "redux/features/cliente/cliente-slice";
import { addTypeFlowState } from "redux/features/security/security-slice";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { RouteNames } from "routes/routes";
import Endpoints from "services/api/endpoints";
import { moneyMask } from "utils/mask";
import { showMessage } from "utils/messages";
import * as St from "./styles";

const ChoosePayments = (props: any) => {
  const [selectedMethod, setSelectedMethod] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { state } = useLocation<any>();
  const { idFatura } = state;

  const antecipationList = useSelector(selectAntecipationList);

  const antecipationIdFatura = antecipationList?.map((item) => item.idFatura);

  const handleConfirm = () => {
    if (selectedMethod === "pix") {
      clickPixAntecipation();
    } else if (selectedMethod === "caixa") {
      requestAntecipation();
    }
  };

  const {
    cliente: { valueAntecipationPurchase },
  } = useAppSelector((state) => state.cliente);

  const PostCreateAntecipation = useApi<any>(
    Endpoints.cobranca.postCreateAntecipationPurchase,
    ApiMethod.POST,
  );

  const clickBack = () => {
    history.push(RouteNames.ATENDIMENTO_FATURA);
    dispatch(addTypeFlowState("fatura"));
  };

  const clickPixAntecipation = () => {
    dispatch(addTypeFlowState("fatura-pix"));
    history.push({
      pathname: RouteNames.PAGAMENTO_PIX_FATURA,
      state: {
        idFatura: antecipationIdFatura,
        antecipation: true,
        totalCompra: state.totalCompra,
      },
    });
  };

  const clickPIX = () => {
    dispatch(addTypeFlowState("fatura-pix"));
    history.push({
      pathname: RouteNames.PAGAMENTO_PIX_FATURA,
      state: { idFatura: idFatura },
    });
  };

  const requestAntecipation = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Solicitando antecipação..."));

    const payload: any[] = [];

    antecipationList?.forEach((item: any) => {
      payload.push({
        cartao: item.cartao,
        dataCompra: item.dataCompra,
        dataFechamento: String(moment(item?.dataCorte).format("YYYY-MM-DD")),
        cpf: item.cpf,
        email: item.email,
        id_fatura: item.idFatura,
        idParcelamento: item.idCompra,
        nomeCliente: item.nomeCompleto,
        parcelasAntecipadas: item.qtdParcelasAPagar,
        valorAntecipacao: item?.valorPendente,
        tipoAntecipacao: "COMPRA",
        origemAntecipacao: "TOTEM",
      });
    });

    const response = await PostCreateAntecipation.callApi(payload);

    if (response.status >= 200 && response.status < 300) {
      dispatch(setLoading(false));
      showMessage(
        "success",
        "Antecipação de compra",
        "Antecipação solicitada com sucesso! Dirija-se ao caixa para concluir o pagamento.",
      );
      history.push(RouteNames.RESUMO_ANTECIPACAO_COMPRA);
    } else {
      dispatch(setLoading(false));
      const { mensagem } = response.data;
      showMessage("warning", "Atenção!", mensagem as string);
      history.push(RouteNames.ATENDIMENTO_ANTECIPACAO);
    }
  };

  const clickCredCard = () => {
    dispatch(addTypeFlowState("fatura-pagamento-credito"));
    const propsRouter: SecurityPageProps = {
      nextStep: RouteNames.CAPTURA_VALOR_FATURA_PAGAMENTO,
      backStep: RouteNames.ESCOLHA_PAGAMENTO,
    };

    history.push({
      pathname: RouteNames.CAPTURA_VALOR_FATURA_PAGAMENTO,
      state: { ...propsRouter },
    });
  };

  const clickDebitCard = () => {
    dispatch(addTypeFlowState("fatura-pagamento-debito"));
    const propsRouter: SecurityPageProps = {
      nextStep: RouteNames.CAPTURA_VALOR_FATURA_PAGAMENTO,
      backStep: RouteNames.ESCOLHA_PAGAMENTO,
    };

    history.push({
      pathname: RouteNames.CAPTURA_VALOR_FATURA_PAGAMENTO,
      state: { ...propsRouter, totalCompra: state.totalCompra },
    });
  };

  return (
    <ContainerFlex>
      <St.TitleH1>Pagamento</St.TitleH1>
      <ContainerFlex>
        <ContainerFlex center>
          <St.SpanDescription>
            {state.antecipation
              ? "Como deseja pagar tua antecipação de compras:"
              : "Como deseja pagar tua fatura:"}
          </St.SpanDescription>
          {state?.antecipation && (
            <St.TitleH1>{`Valor total: ${moneyMask(
              valueAntecipationPurchase,
            )}`}</St.TitleH1>
          )}
          <ContainerFlex center row>
            {state.antecipation ? (
              <>
                <ContainerFlex row center space>
                  <button
                    className={
                      selectedMethod === "pix" ? "selected normal" : "normal"
                    }
                    onClick={() => setSelectedMethod("pix")}
                  >
                    PIX
                  </button>

                  <button
                    className={
                      selectedMethod === "caixa" ? "selected normal" : "normal"
                    }
                    onClick={() => setSelectedMethod("caixa")}
                  >
                    Caixa
                  </button>
                </ContainerFlex>
              </>
            ) : (
              <ContainerFlex row space>
                <button className="normal" onClick={() => clickPIX()}>
                  PIX
                </button>
                {/* <button className="normal" onClick={() => clickCredCard()}>
                  Cartão de crédito
                </button>
                <button className="normal" onClick={() => clickDebitCard()}>
                  Cartão de débito
                </button> */}
              </ContainerFlex>
            )}
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <St.FooterFixed>
        <ContainerFlex center horizontal row space>
          <AppButton
            content="Voltar"
            route={
              state?.antecipation
                ? RouteNames.ATENDIMENTO_ANTECIPACAO
                : RouteNames.ATENDIMENTO_FATURA
            }
            outlined={true}
            click={clickBack}
          />
          {selectedMethod && (
            <AppButton content="Confirmar" click={handleConfirm} />
          )}
        </ContainerFlex>
      </St.FooterFixed>
    </ContainerFlex>
  );
};

export default ChoosePayments;
